module.exports = "/_next/static/images/Hero@2x-4666ca7f662303c6be6ca70adac8d059.webp";